/*
 * @Description:
 * @Author: Teemo D
 * @Date: 2021-03-29 14:42:59
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-08 11:19:01
 * @FilePath: /unifyxp-v2-store-portal的副本/src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage/Preview/index.tsx
 */
import React from 'react';

import { IEdmType, IFeatureProduct } from 'src/types/common/SalesChannel';
import { EDM, FeatureProduct, MyCenter } from 'unifyxp-ecomm-components';

import { withDraggableId } from 'src/constrains/Preview/util';
import { EnumCollapseId } from '../common';
import { onCollapseOpen } from '../slice';
import styles from './style.module.less';
interface Props {
  featureProducts: IFeatureProduct;
  image: string;
  backgroundColor: string;
  // policy: PolicyType[];
  edmData: IEdmType;
}

const Preview = ({
  featureProducts,
  image,
  backgroundColor,
  edmData,
}: Props) => {
  const {
    moduleType,
    title = '',
    backgroundColor: edmBackgroundColor = '',
    textColor = '',
    buttonStyle,
    tacs = [],
    fields = [],
    showInProfilePage = false,
  } = edmData;

  const {
    text = '',
    backgroundColor: buttonBackgroundColor,
    textColor: buttonTextColor,
  } = buttonStyle || {};
  const { moduleType: moduleTypeFeatures } = featureProducts;
  const _EDM = withDraggableId(EDM, `module_${moduleType}`, onCollapseOpen);

  const _MyCenter = withDraggableId(
    MyCenter,
    EnumCollapseId.backgroundStyle,
    onCollapseOpen,
  );

  const _FeatureProduct = withDraggableId(
    FeatureProduct,
    `module_${moduleTypeFeatures}`,
    onCollapseOpen,
  );

  return (
    <div className={styles.container}>
      <_MyCenter
        image={image || ''}
        backgroundColor={backgroundColor || '#000000'}
      />
      {featureProducts.isValid && (
        <div className={styles.featureContainer}>
          <_FeatureProduct
            title={featureProducts.title}
            products={featureProducts.dataSet}
            titleColor={featureProducts.titleTextColor}
            style={{
              backgroundColor: backgroundColor,
            }}
          />
        </div>
      )}
      {showInProfilePage && (
        <div
          className={styles.edmContainer}
          style={{ backgroundColor: edmBackgroundColor }}>
          <_EDM
            title={title}
            backgroundColor={edmBackgroundColor}
            textColor={textColor}
            buttonText={text}
            buttonBackgroundColor={buttonBackgroundColor}
            buttonTextColor={buttonTextColor}
            termsNcondition={tacs || []}
            fields={fields || []}
          />
        </div>
      )}
    </div>
  );
};

export default Preview;
